/**
 * Created by wuhuping on 2017/5/16.
 */
export default {
  // phone check
  checkPhone(phone) {
    let reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
    return reg.test(phone);
  },
  // email check
  checkEmail(email) {
    let reg = /^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/;
    return reg.test(email);
  },
  // verify code check
  checkVerifyCode(code) {
    let reg = /^\d{6}$/;
    return reg.test(code);
  },
  // dynamic code check
  checkDynamicCode(code) {
    let reg = /^[A-Za-z0-9]{4}$/;
    return reg.test(code);
  },
  // password check
  checkPassword(password) {
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
    return reg.test(password);
  },
  // name check
  checkName(name) {
    let reg = /^[\u4e00-\u9fa5]{2,17}$/;
    return reg.test(name);
  },
  // idCard check
  checkIDCard(idCard) {
    if (idCard.length === 18) {
      let reg = /^\d{17}[\d|X|x]$/;
      return reg.test(idCard);
    } else if (idCard.length === 15) {
      let reg = /^\d{15}$/;
      return reg.test(idCard);
    } else {
      return false;
    }
  },
  // bankCard check
  checkBankCard(bankCard) {
    return bankCard.length >= 15 && bankCard.length <= 19;
  },
  // empty check
  checkEmpty(str) {
    if (str === undefined || str === null || str.length <= 0 || str === 'undefined') {
      return true;
    } else {
      return false;
    }
  },
  // 检测电话号码的位数
  checkPhonePlaces(str) {
    if (str.length === 11) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/validator.js